/*
 * @Author: dengyong dengyong@caohua.com
 * @Date: 2022-08-11 20:29:20
 * @LastEditors: dengyong dengyong@caohua.com
 * @LastEditTime: 2022-08-11 20:31:26
 * @FilePath: /tiangong/src/data/uc/app_type.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default [
  {
    id: 2,
    value: '游戏',
    children: [
      {
        id: 5015,
        value: '辅助工具',
        children: [

        ]
      },
      {
        id: 6001,
        value: '休闲益智',
        children: [

        ]
      },
      {
        id: 6002,
        value: '飞行射击',
        children: [

        ]
      },
      {
        id: 6003,
        value: '跑酷竞速',
        children: [

        ]
      },
      {
        id: 6004,
        value: '动作冒险',
        children: [

        ]
      },
      {
        id: 6005,
        value: '体育竞技',
        children: [

        ]
      },
      {
        id: 6006,
        value: '角色扮演',
        children: [

        ]
      },
      {
        id: 6007,
        value: '经营策略',
        children: [

        ]
      },
      {
        id: 6008,
        value: '扑克棋牌',
        children: [

        ]
      },
      {
        id: 6009,
        value: '网络游戏',
        children: [

        ]
      }
    ]
  },
  {
    id: 1,
    value: '软件',
    children: [
      {
        id: 5014,
        value: '通讯社交',
        children: [

        ]
      },
      {
        id: 5016,
        value: '摄影图像',
        children: [

        ]
      },
      {
        id: 5017,
        value: '网上购物',
        children: [

        ]
      },
      {
        id: 5018,
        value: '系统工具',
        children: [

        ]
      },
      {
        id: 5019,
        value: '新闻阅读',
        children: [

        ]
      },
      {
        id: 5020,
        value: '生活休闲',
        children: [

        ]
      },
      {
        id: 5021,
        value: '旅游出行',
        children: [

        ]
      },
      {
        id: 5022,
        value: '办公商务',
        children: [

        ]
      },
      {
        id: 5023,
        value: '金融理财',
        children: [

        ]
      },
      {
        id: 5024,
        value: '手机美化',
        children: [

        ]
      },
      {
        id: 5026,
        value: '考试学习',
        children: [

        ]
      },
      {
        id: 5027,
        value: '育儿亲子',
        children: [

        ]
      },
      {
        id: 5028,
        value: '健康运动',
        children: [

        ]
      },
      {
        id: 5029,
        value: '影音播放',
        children: [

        ]
      }
    ]
  }
]
